import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import moment from 'moment-timezone'
import { useSelector, useDispatch } from 'react-redux'

import { dateNotationSelector } from 'selectors/current_user'
import { userDateFormat } from 'services/time_format'

import { cancelRequest } from './slice'

const EventsDetails = ({ request }) => {
  const dateNotation = useSelector(dateNotationSelector)
  const dateFormat = 'date_small_with_year'

  const dates = {
    start_time: userDateFormat(moment(request.start_time).tz('UTC'), dateNotation, dateFormat),
    end_time: userDateFormat(moment(request.end_time).tz('UTC'), dateNotation, dateFormat),
  }

  const text = HtmlParser(
    I18n.t('publisher.organization_settings.data_deletion.section.deletion_requests.cancelation.body.events', dates)
  )

  return (
    <div data-testid="sub-description">
      {text}
    </div>
  )
}

const InviteesDetails = ({ request }) => (
  <>
    <div data-testid="sub-description">
      {I18n.t('publisher.organization_settings.data_deletion.section.deletion_requests.cancelation.body.invitees')}
    </div>
    {request.emails && request.emails.map((email) => <div key={email}><FullStoryMask>{email}</FullStoryMask></div>)}
  </>
)

const Details = ({ request }) => {
  switch (request.type) {
    case 'InviteesDeletion':
      return <InviteesDetails request={request} />
    case 'EventsDeletion':
      return <EventsDetails request={request} />
    default:
      return null
  }
}

export const CancelationPopup = ({ onClose, request }) => {
  const dispatch = useDispatch()
  const dateNotation = useSelector(dateNotationSelector)

  const confirmCancelation = () => {
    onClose()
    dispatch(cancelRequest({ request }))
  }

  return (
    <Popup
      onClose={onClose}
      title={I18n.t(
        'publisher.organization_settings.data_deletion.section.deletion_requests.cancelation.title',
        { date: userDateFormat(moment(request.created_at), dateNotation, 'date_small_with_year') }
      )}
    >
      <Body>
        <Details request={request} />
      </Body>
      <Footer>
        <Button decoration="secondary-outline" onClick={onClose}>
          {I18n.t('publisher.organization_settings.data_deletion.section.deletion_requests.cancelation.close')}
        </Button>
        <Button decoration="danger" onClick={confirmCancelation}>
          {I18n.t('publisher.organization_settings.data_deletion.section.deletion_requests.cancelation.confirm')}
        </Button>
      </Footer>
    </Popup>
  )
}
